import acs, { ACS } from "@mos-utils/acs";
import { useEffect } from "react";

/**
 * @public
 */
export function useACSSubscription(
  subscription: Parameters<ACS["subscribe"]>[0]
): void {
  useEffect(
    function () {
      return acs.subscribe(subscription);
    },
    [subscription]
  );
}
